import React from 'react';
import css from '../ListingPage.css';
import PageLayout from '../components/PageLayout';

export default ({ intl, appIsMounted, scrollingDisabled, noIndexTag }) => {
    // Other error in fetching listing

    const errorTitle = intl.formatMessage({
        id: 'ListingPage.errorLoadingListingTitle',
    });

    return (
        <PageLayout
            showTopBar={appIsMounted}
            title={errorTitle}
            scrollingDisabled={scrollingDisabled}
            metaTags={noIndexTag}
        >
            <p className={css.errorText}>Konnte Inserat nicht laden. Bitte versuche es nochmals.</p>
        </PageLayout>
    );
};
